import { StringsType } from "./en"

export const fr: StringsType = {
  bubbleExpiration: {
    expiredTitle: "Premium gratuit a expiré",
    expiredSubtitle: "Passez à Premium pour la meilleure expérience PhotoVault",
    expiredSubtitlePremium:
      "Passez à Premium pour une excellente expérience PhotoVault",
    expiredSubtitleUltimate:
      "Passez à Ultimate pour la meilleure expérience PhotoVault",
    trashRecovery: "Récupération de la corbeille",
    cloudVault: "Cloud Vault",
    spaceSaver: "Space Saver",
    noAds: "Pas de publicités",
    everyPremiumFeature: "Obtenez toutes les\nfonctionnalités Premium",
    everyUltimateFeature: "Obtenez toutes les\n fonctionnalités Ultimate",
    unlockUltimateTools:
      "Débloquez tous les outils de confidentialité de l'application.",
    cloudVaultUltimate: "Cloud Vault - 1 000 Go",
    organizationPlus: "Organisation+",
    organizationPlusDesc:
      "Créer des sous-albums, trouver des doublons et plus encore.",
    perMonth: "par mois",
    perYear: "par an",
    justOnce: "une seule fois",
    lifetime: "À vie",
    threeMonths: "3 Mois",
    lifetimeTitle: "Plan à vie",
    lifetimeDescription:
      "Le plan à vie sera bientôt disponible. Restez à l'écoute pour les mises à jour!",
    lifetimeFeature1: "Paiement unique",
    lifetimeFeature2: "Accès à vie à toutes les fonctionnalités",
    lifetimeFeature3: "Meilleure valeur pour les utilisateurs à long terme",
    lifetimeCta: "Acheter Lifetime",
    lifetimeSheetDisclaimer: "Sauvegarde cloud (50GB) incluse pendant 5 ans.",
    lifetimeSheetDisclaimerDetailed:
      "5 années de sauvegarde Cloud Vault (50 GB) sont incluses avec votre plan à vie. Après, vous serez éligible à un abonnement Cloud Vault à prix réduit disponible uniquement pour les membres à vie. Toutes les fonctionnalités Premium resteront toujours disponibles sans coût supplémentaire.",
    lifetimeDisclaimerCloudStorage:
      "5 années de sauvegarde Cloud Vault (50 GB) sont incluses avec votre plan à vie.",
    lifetimeDisclaimerAfterPeriod:
      "Après 5 ans, vous serez éligible à un abonnement Cloud Vault à prix réduit disponible uniquement pour les membres à vie.",
    lifetimeDisclaimerPremiumFeatures:
      "Toutes les fonctionnalités Premium resteront toujours disponibles sans coût supplémentaire.",
    monthly: "Mensuel",
    yearly: "Annuel",
    selectPlan: "Sélectionnez un plan pour continuer",
    unlockPrivacyTools: "Débloquez d'excellents outils de confidentialité.",
    cloudVaultGB: "Cloud Vault - 50 GB",
    secureBackups: "Sauvegardes sécurisées qui restent chiffrées.",
    freeUpSpace: "Libérez de l'espace sur votre téléphone.",
    recoverDeleted: "Récupérez les éléments supprimés de la corbeille.",
    fullExperience: "L'expérience complète sans interruptions.",
    restorePurchases: "Restaurer les achats",
    basicTitle: "Private Photo Vault Basic",
    free: "GRATUIT",
    basicDescription:
      "Basic est la version gratuite de PhotoVault. Il protège toujours vos photos importantes derrière un écran PIN et vous offre de bonnes fonctionnalités de confidentialité.",
    switchToBasic: "Passer à Basic",
    termsOfService: "Conditions de service",
    privacy: "Confidentialité",
    switchToPremium: "Passer à Premium",
    switchToUltimate: "Passer à Ultimate",
  },
  title: "Accès illimité à toutes les fonctions",
  freeTrial: "Essai gratuit",
  startPlan: "Démarrer le forfait",
  pricePerMonth: (price: any) => `${price}/mois`,
  pricePerYear: (price: any) => `${price} par an`,
  discount: (discount: number) => `${discount}% DE RÉDUCTION`,
  new: "nouveau",
  trashRecovery: "Restauration de la corbeille",
  adFree: "Expérience sans publicité",
  breakIn: "Rapport d'effraction : photo et GPS",
  wireless: "Transfert de photos sans fil",
  decoy: "Code leurre",
  pattern: "Schéma",
  appDisguise: "Déguisement",
  comingSoon: "bientôt disponible",
  subscriptionTerms: "Conditions de l'abonnement:",
  terms:
    "Le paiement sera débité sur votre compte iTunes lors de la confirmation de l'achat. L'abonnement se renouvelle automatiquement si le renouvellement automatique n'est pas désactivé au moins 24 heures avant la fin de la période en cours. Le compte sera débité de la somme correspondant au renouvellement dans les 24 heures précédant la fin de la période en cours. Vous pouvez gérer votre abonnement et désactiver le renouvellement automatique en accédant aux paramètres de votre compte après l'achat.",
  privacy: "Confidentialité",
  alreadyPurchased: "Avez-vous déjà acheté ?",
  termsButton: "Conditions",
  monthly: "PAR MOIS",
  yearly: "ANNUELLEMENT",
  popular: "POPULAIRE",
  save: (discount) => `ÉCONOMISEZ ${discount}%`,
  anniversaryTitle: (discount) =>
    `Offre d'anniversaire - ÉCONOMISEZ ${discount}%`,
  blackFridayTitle: (discount) => `Vendredi noir - ÉCONOMISEZ ${discount}%`,
  year: "an",
  years: "ans",
  hour: "heure",
  hours: "heures",
  minute: "minute",
  minutes: "minutes",
  second: "seconde",
  seconds: "secondes",
  promoSubtitle: (hours) =>
    `Dépêchez-vous, cette vente ne durera que ${hours} heures`,
  offerExpires: "Jusqu'à l'expiration de l'offre",
  unlockDeal: "Débloquer l'offre",
  blackFridayPaywallTitle: "Offre du Black Friday",
  anniversaryPaywallTitle: "Votre offre d'anniversaire 🎉",
  blackFridayPaywallSubtitle:
    "Ne manquez pas cette offre unique pour le Black Friday ! Bénéficiez d'énormes économies sur notre abonnement annuel.",
  anniversaryPaywallSubtitle: (years: number, discount: number) =>
    `Félicitations pour ${years} ans avec nous ! Pour célébrer, voici une remise de ${discount}% sur Premium. Merci pour votre fidélité !`,
  blackFridayAnnualTitle: "Votre offre du Black Friday 🎉",
  anniversaryAnnualTitle: "Votre offre d'anniversaire 🎉",
  oneYear: "1 an",
  oneMonth: "1 mois",
  lockedIn: "Ce prix annuel sera verrouillé POUR TOUJOURS",
  subtitleFixed: "Dépêchez-vous, cette vente se terminera bientôt!",
  importTitle: "Ajoutez des photos à votre coffre-fort sécurisé",
  importSubtitle: "C'est 100% privé !",
  importInfo:
    "Notre chiffrement à connaissance zéro garantit que vos données restent privées, même pour nous.",
  importCTA: "Sélectionner des photos",
  totalMonthsPrice: (price: string) => `12 mois • ${price}`,
  monthlyPrice: (price: string) => `${price} / mois`,
  oneTimeOffer: {
    title: "Votre offre unique",
    subTitle: "Une fois votre offre unique fermée, elle disparaîtra !",
    claim: "Réclamez votre offre unique",
  },
  returnOffer: {
    monthly: (price: string) => `aussi bas que ${price}/mois`,
    title: "Votre Offre Exclusive de Retour",
    subTitle:
      "Réactivez votre adhésion aujourd'hui à un tarif spécial! Disponible pour un temps limité seulement",
    discountTitle: "Remise Spéciale",
    cta: "Réactiver Maintenant",
    discountSubTitle: "Offre limitée dans le temps",
  },
  off: "RÉDUCTION",
  special: "SPÉCIAL",
  yearlyPlan: "Plan Annuel",
  monthlyPlan: "Plan Mensuel",
  subscribe: "Souscrire",
  cancelAnytime: "Annuler à tout moment",
  freeTrialPaywall: {
    title: "Comment fonctionne votre essai gratuit",
    firstStep: {
      title: "Maintenant",
      subtitle:
        "Débloquez un accès illimité à Private Photo Vault et ne vous inquiétez plus de qui peut voir vos photos privées",
    },
    secondStep: {
      title: "Aujourd'hui : Commencez votre essai gratuit",
      subtitle:
        "Débloquez un accès complet à PhotoVault. Vous ne serez pas facturé aujourd'hui.",
    },
    thirdStep: {
      title: "Dans 7 jours",
      subtitle:
        "Vous serez facturé ce jour-là. Annulez à tout moment avant, sans tracas.",
    },
    whatsIncluded: "Voir ce qui est inclus",
    viewAllPlans: "Voir tous les plans",
    startTrial: "Commencez l'essai gratuit",
    footerTitle: (yearlyPrice, monthlyPrice) =>
      `7 jours GRATUITS puis ${yearlyPrice}/an\n(${monthlyPrice} par mois)`,
    footerDisclaimer:
      "Annulez à tout moment avant la fin de votre essai. Vous ne serez facturé qu'après 7 jours",
    featureList: {
      title: "Qu'est-ce que Private Photo Vault ?",
      infoTitle: "100% Privé et Sécurisé",
      infoSubtitle: "Protégez vos données et empêchez tout accès non autorisé",
      subTitle: "Passez à Premium et obtenez l'accès à :",
    },
    comparePlans: {
      monthly: "Mensuel",
      ultimateYearly: "Ultimate annuel",
      yearly: "Annuel",
      threeMonths: "3 mois",
      freeFor: (days) => `Gratuit pendant ${days} jours`,
      monthlyPrice: (price) => `seulement ${price}/mois`,
      dailyPrice: (price) => `seulement ${price}/jour`,
      cta: "Continuer",
    },
  },
  comparePlans: {
    title: "Comparer les plans",
    compare: "Comparer",
    freeTitle: "Gratuit",
    basicTitle: "De base",
    premiumTitle: "Premium",
    ultimateTitle: "Ultimate",
    unlockPremium: "Débloquer Premium",
    unlockUltimate: "Débloquer Ultimate",
    choose: "Choisissez un plan",
  },
  features: {
    organizationPlus: "Organisation+",
    securityPlus: "Sécurité+",
    duplicateDetection: "Détection de doublons",
    faceDownLock: "Verrouillage face vers le bas",
    customIcons: "Icônes personnalisées",
    encryptedStorage: "Stockage de photos crypté",
    unlimitedAlbums: "Albums illimités",
    browser: "Navigateur web sécurisé",
    camera: "Caméra privée",
    subalbums: {
      title: "Sous-albums",
      description:
        "Créez plusieurs niveaux de sous-albums pour organiser votre contenu efficacement.",
    },
    filteringAndSearching: {
      title: "Filtrage et recherche",
      description:
        "Recherchez dans vos albums et appliquez des filtres pour trouver des types de contenu spécifiques.",
    },
    alphanumericPasscode: {
      title: "Code d'accès alphanumérique",
      description:
        "Renforcez la sécurité de votre application en utilisant un mot de passe alphanumérique.",
    },
    dualLock: {
      title: "Exigez un code d'accès + Face ID",
      description:
        "Pour plus de sécurité, exigez à la fois le code d'accès et Face ID à chaque fois que vous entrez dans l'application.",
    },
    locationBasedLock: {
      title: "Verrouillage basé sur la localisation",
      description:
        "Permet de déverrouiller l'application uniquement dans des emplacements GPS approuvés.",
    },
  },
  gotIt: "Compris!",
  promo: {
    premiumSave: (percent: string) => `ÉCONOMISEZ ${percent}% SUR PREMIUM`,
    monthly: (price: string) => `Seulement ${price}/mois`,
    yearly: (price: string) => `${price}/an`,
    limited: "TEMPS LIMITÉ RESTANT",
    claimOffer: "Réclamer l'offre",
    seconds: (count: number) => (count == 1 ? "SECONDE" : "SECONDES"),
    minutes: (count: number) => (count == 1 ? "MINUTE" : "MINUTES"),
    oneTimeOffer: "OFFRE UNIQUE",
    normalFee: "tarif normal",
    backTo: "retour à",
    yearlyShort: (price: string) => `${price}/an`,
  },
  premiumToUltimateBlackFriday: {
    title: "VENTE DU BLACK FRIDAY",
    subTitle: "DEVENEZ ULTIMATE",
    cloud: {
      title: "1 000 Go de stockage cloud",
      description: "Stockage cloud sécurisé pour 500 000+ photos",
    },
    duplicateDetection: {
      description: "Localisez et supprimez les images en double",
    },
    organizationPlus: {
      description: "Créez des sous-albums, filtrez et recherchez vos photos",
    },
    securityPlus: {
      description:
        "Sécurité renforcée avec mot de passe alphanumérique, verrouillage basé sur la localisation et plus encore",
    },
    timeRemaining: "TEMPS RESTANT",
    saleBanner: "VENTE MÉGA TEMPS LIMITÉ",
    saleTitle: "Offre Black Friday 🎉",
    monthPrefix: "12 mois • ",
    perMonthPrice(price: string) {
      return `${price} / mois`
    },
    monthly: "Mensuel",
    ultimateLaunch: {
      title: "PASSER À Ultimate",
      saleTitle: "Offre de Lancement Ultimate 🚀",
      bannerTitle: (discount) => `Lancement Ultimate - ÉCONOMISEZ ${discount}%`,
    },
  },
  beforeYouGo: {
    title: "Attendez - Avant de partir",
    subtitle: "Gardez vos photos sécurisées et privées",
    subtitle2: "Obtenez 7 jours de Premium totalement gratuits.",
    cta: "Commencez votre essai gratuit",
    cancelTitle:
      "Annulez à tout moment avant la fin de votre essai et vous ne serez pas facturé avant la fin des 7 jours.",
    skipCta: "Non merci",
  },
  enableTrial: "Pas encore sûr ? Activez l'essai gratuit",
  startTrial: "Commencez l'essai gratuit",
  trialActivated: (days) => `ESSAI DE ${days} JOURS ACTIVÉ`,
  specialOffer: {
    enabledTitle: "Offre spéciale activée",
    trialTitle: "Profitez de votre essai gratuit de 7 jours supplémentaire",
    expirationTitle: "Votre abonnement expire bientôt !",
    expirationSubtitle: "Renouvelez à un tarif spécial !",
    priceBoxExpiration: {
      title: "Offre spéciale de renouvellement",
      offerName: "Abonnement annuel",
      ctaTitle: "Profiter de l’offre spéciale",
    },
    priceBoxTrial: {
      title: "Offre exclusive : 7 jours d’essai gratuits supplémentaires",
      offerName: "Essai supplémentaire de 7 jours",
      ctaTitle: "Profiter de l’essai gratuit",
    },
  },
  premiumToUltimate: {
    titleLine1: "PASSAGE À L’ULTIMATE",
    titleLine2: "OFFRE UNIQUE",
    megaSaleBanner: "VENTE FLASH À DURÉE LIMITÉE",
    upgradeTitle: "Offre de mise à niveau Ultimate",
    yearlySubtitlePrefix: "12 mois •",
    monthlyPriceSuffix: "/ mois",
  },
  monthlyToYearly: {
    titleLine1: "Passage à l’abonnement annuel",
    titleLine2: "Offre unique",
    subtitleWarning: "Une fois fermée, cette offre disparaîtra à jamais !",
    specialLabel: "SPÉCIAL",
    offerTitle: "Profitez de votre offre unique",
    offerName: "Formule annuelle",
    subscribeButton: "S’abonner",
    cancelAnytime: "Annulable à tout moment",
    yearlySubtitlePrefix: "12 mois •",
    monthlyPriceSuffix: "/ mois",
  },
  expiration: {
    warmup: {
      close: "FERMER",
      subtitle:
        "Gardez vos photos SÉCURISÉES et RÉCUPÉRABLES en cas de perte ou de vol de votre téléphone",
      features: {
        cloudVault: {
          title: "Cloud Vault",
          subtitle: "Sauvegarde chiffrée de vos fichiers",
        },
        cloudVaultUltimate: {
          title: "Cloud Vault",
          subtitle: "1 000 Go de stockage Cloud Vault",
        },
        reviews: {
          title: "Plus de 500 000 avis 5 étoiles",
          subtitle: "Fiable par des millions d’utilisateurs",
        },
        noAds: {
          title: "Sans publicités",
          subtitle: "Expérience sans pub",
        },
        organizationPlus: {
          title: "Organization+",
          subtitle: "Sous-albums, meilleurs filtres et plus",
        },
      },
      footer: "& toutes les fonctionnalités !",
      switchToPremium: "Passer à Premium",
      switchToUltimate: "Passer à Ultimate",
      titlePremium: "Votre Premium a expiré !",
      titleUltimate: "Votre Ultimate a expiré !",
      popular: "POPULAIRE",
      perMonth: "par mois",
      perYear: "par an",
    },
    titlePremium: "Premium a expiré",
    titleUltimate: "Ultimate a expiré",
    subtitlePremium:
      "Renouvelez Premium pour conserver vos fonctionnalités ou passez à Basic gratuitement",
    subtitleUltimate:
      "Renouvelez Ultimate pour conserver vos fonctionnalités ou passez à Basic gratuitement",
    basicButton: "Passer à Basic",
    basicTitle: "Qu’est-ce que Basic ?",
    basicDescription:
      "Basic est la version gratuite de l’application. Vous pouvez toujours protéger vos photos et vidéos avec un code PIN. Cependant, vous perdrez l’accès à la sauvegarde Cloud Vault chiffrée et à toutes les autres fonctionnalités Premium",
  },
  animated: {
    title: "Choisissez votre offre",
    yearlyPrice: (price: string) => `Seulement ${price} par an`,
    subtitle: "Renouvellement automatique. Annulez à tout moment",
    cta: "Continuer",
    trial: "Essai gratuit activé",
    breakinShort: "Rapport d'effraction",
    unlimitedPhotos: "Photos illimitées",
  },
  choosePlanTitle: "Choose Your Plan",
  multistep: {
    lockTitle: "Verrouillez les photos privées",
    subtitle: {
      line1: "Nous offrons",
      line2: "7 jours gratuits",
      line3: "pour que tout le monde puisse protéger ses photos",
    },
    subtitleReminder: {
      line1: "Vous recevrez un rappel ",
      line2: "2 jours ",
      line3: "avant la fin de l'essai.",
    },
    noPaymentNow: "Aucun paiement maintenant",
    startFreeWeek: "Commencez votre semaine GRATUITE",
    payTitle: "7 jours gratuits",
    afterPrice: (price: string) => `puis ${price} / mois`,
    afterBilling: (price: string) => `(facturé ${price} par an après l’essai)`,
    footerTitle: (price) => `Gratuit pendant 7 jours. Puis ${price}/an`,
    footerMonthlyTitle: (price) => `Vous serez facturé ${price} immédiatement.`,
    headerTitle: "Essai gratuit de 7 jours",
    anual: "Annuel",
    monthly: "Mensuel",
    noTrial: "Pas d’essai gratuit",
    yearlyPrice: (price) => `${price} / An`,
  },
  oneTimeOfferTitle: "OFFRE UNIQUE",
  unlockPremiumFor: "Débloquez l'abonnement Premium annuel pour",
  oneTimeOfferSubtitle: "Ceci est une offre unique",
  lowestPrice: "LE PRIX LE PLUS BAS JAMAIS VU",
  summerSale: {
    title: "SOLDES D'ÉTÉ",
    tagline: "Le soleil voit tout... sauf ce qui est dans votre coffre !",
    timeRemaining: "L'offre expire bientôt",
    limitedTimeOffer: "Offre à durée limitée",
    savePercent: (percent: number) => `Économisez ${percent}%`,
    bannerSubtitle: (price: string) => `Obtenez Premium pour ${price}`,
    bannerSubtitleUltimate: (price: string) => `Obtenez Ultimate pour ${price}`,
    getPremium: "Obtenir la confidentialité Premium",
    getUltimate: "Obtenir la confidentialité Ultimate",
    hours: "heures",
    minutes: "minutes",
    seconds: "secondes",
    features: {
      premiumFeature: {
        title: "Obtenez toutes les fonctionnalités Premium",
        description: "Outils Premium qui protègent votre vie privée.",
      },
      cloudVault: {
        title: "Cloud Vault - 50 GB",
        description: "Sauvegardes sécurisées qui restent chiffrées.",
      },
      noAds: {
        title: "Sans publicité",
        description: "L'expérience complète sans interruptions.",
      },
      faceDownLock: {
        title: "Verrouillage face cachée",
        description:
          "Verrouillez l'app instantanément en retournant votre téléphone.",
      },
      breakInReports: {
        title: "Rapports d'intrusion",
        description: "Alertes si quelqu'un essaie d'accéder à votre coffre.",
      },
    },
    pricing: {
      summerSale: "Soldes d'été",
      monthly: "Mensuel",
      perMonth: (price: string) => `${price} / mois`,
      twelveMonths: "12 mois",
      originalPrice: (price: string) => price,
      discountedPrice: (price: string) => price,
    },
  },
  halloweenSale: {
    title: "HALLOWEEN SALE",
    tagline: "La nuit cache bien des choses…\nsurtout les vôtres !",
    buttonTitle: "Halloween Sale",
  },
  emailPromo: {
    title: "Offre Premium Exclusive",
    upgradeButton: "Passer à Premium",
    yearlyTitle: "Premium Annuel",
    decoyDescription:
      "Créer un coffre-fort factice qui s'ouvre avec un mot de passe leurre",
  },
  onboardingUltimateAlternate: {
    title: "Commencez votre essai gratuit",
    premiumDescription: "Débloquez d'excellents outils de confidentialité.",
    ultimateDescription: "La meilleure expérience de Photo Vault.",
    includesPremium: "Inclut Premium",
    trialPricing: (yearlyPrice: string, monthlyPrice: string) =>
      `7 jours gratuits, puis ${yearlyPrice} (${monthlyPrice}/mois)`,
    timeline: {
      today: "Aujourd'hui :",
      todayDescription: "commencez votre essai gratuit",
      day5: "Jour 5 :",
      day5Description: "recevez un rappel",
      day7: "Jour 7 :",
      day7Description: (yearlyPrice: string) =>
        `vous serez facturé ${yearlyPrice}`,
    },
    comparisonTable: {
      header: "Ce que vous obtenez",
    },
    didYouKnow: {
      label: "Le saviez-vous ?",
      statNumber: "3X",
      statDescription:
        "Les abonnés obtiennent 3 fois plus de tranquillité d'esprit",
    },
    pricing: {
      yearlyPlanTitle: "Plan annuel",
      yearlyPlanSubtitle: (yearlyPrice: string) => `${yearlyPrice}/an`,
      yearlyAmount: (monthlyPrice: string) => `${monthlyPrice}/mois`,
      monthlyTitle: "Mensuel",
      monthlyAmount: (monthlyPrice: string) => `${monthlyPrice}/mois`,
      popularBadge: "POPULAIRE",
    },
    ctaButton: "Commencer l'essai gratuit",
  },
}
